import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router'

import { EditContainer } from './Edit'
import { HOSPITALS_URL, hospitalsEdit, hospitalsSubscriptionsEdit, } from '../../../constants/urls/frontend'
import { DisplayContainer } from './Display'
import { SubscriptionsEditContainer } from './SubscriptionsEdit'

const HospitalsPage: React.FC<RouteComponentProps> = (): JSX.Element => {
  return (
    <Switch>
      <Route path={hospitalsEdit()} component={EditContainer} />
      <Route path={hospitalsSubscriptionsEdit()} component={SubscriptionsEditContainer} />
      <Route path={HOSPITALS_URL} component={DisplayContainer} />
    </Switch>
  )
}

export {
  HospitalsPage
}
